/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'scopeTrees',
				'scopeTree'
			]
		}
	},

	methods: {
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData = this.getSelectedNodeData();

			if(this.actions[baseActionKey]){
				if(nodeData.scopeID && buttonContext === 'scopeRole'){
					return this.performAction(
						this.prepareAction(baseActionKey, undefined, undefined, {
							source: {
								load: {
									componentData: {
										actions: {
											loadContent: {
												source: {
													load: {
														componentData: {
															model: {
																dirtyFields: {
																	data: {
																		attributes: {
																			scopeID: nodeData.scopeID
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						})
					);
				}
				else {
					return this.performAction(
						this.prepareAction(baseActionKey)
					);
				}
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent) {
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					if(self.actions[baseActionKey]){
						var nodeIndex = self.getSelectedNodeIndex();
						var nodeData = self.getSelectedNodeData();
						self.deselectActiveNode();
						self.setClosestNodeAsReady(nodeIndex);

						if(nodeData._primaryKey){
							return self.performAction(
								self.prepareAction(baseActionKey, nodeData._primaryKey)
							).then(function(context){
								self.refreshTrees();
								return context;
							});
						}
					}
				}

				return utils.promise.reject();
			});

		},

		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();

			if(this.actions[baseActionKey] && nodeData._primaryKey){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData._primaryKey)
				);
			}

			return utils.promise.reject();
		},

		sanitizeResources: function(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Scopes...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var scopeIndex;
			var additionalClasses;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();

				utils.forEach(this.resourceData.data, function (scopeData) {
					resources.initialized = true;

					if(scopeData.attributes) {
						var scope = scopeData.attributes;
						var _primaryKey = scope[scopeData.primaryKey];
						var parent = '#';

						scopeIndex = self.transformIDToIndex(_primaryKey, 'scope', 0, tree.length);

						tree.push({
							id: scopeIndex,
							parent: parent,
							text: scope.name,
							type: 'scope',
							state: {
								opened: true,
								disabled: false,
								selected: false
							},
							li_attr: {},
							a_attr: {}
						});
						scope._primaryKey = _primaryKey;
						nodes[scopeIndex] = scope;


						if(scopeData.children && scopeData.children.um_scopeRoles && scopeData.children.um_scopeRoles.data){
							utils.forEach(scopeData.children.um_scopeRoles.data, function (scopeRoleData) {
								var scopeRole = scopeRoleData.attributes;
								_primaryKey = scopeRole[scopeRoleData.primaryKey];

								var index = self.transformIDToIndex(_primaryKey, 'scopeRole', 0, tree.length);

								additionalClasses = '';
								if(scopeRole.status && scopeRole.status === 'preview'){
									additionalClasses = 'state_preview';
								}
								else if(scopeRole.status && scopeRole.status === 'inactive'){
									additionalClasses = 'state_inactive';
								}

								tree.push({
									id: index,
									parent: scopeIndex,
									text: scopeRole.name + ' [' + scopeRole.status + ']',
									type: 'scopeRole',
									state: {
										opened: true,
										disabled: false,
										selected: false
									},
									li_attr: {},
									a_attr: {
										class: additionalClasses
									}
								});
								scopeRole._primaryKey = _primaryKey;
								nodes[index] = scopeRole;
							});
						}
					}
				});

				this.resourceData = resources;
			}
		},

		/**
		 * support multiple action forms.
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var self = this;

			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'move_node.jstree':
					var moveEntry = data.onTreeActionOptions.eventData.node;
					var moveEntryContext = this.getNodeContext(moveEntry.id);
					var actionKey = data.onTreeActionOptions.operation  + '_' + moveEntryContext;
					if(this.actions[actionKey]){
						var moveNode = this.getNodeData(moveEntry.id);
						var newParentEntry, newParentNode;
						var movementAttributes;
						if(moveEntry.parent && moveEntry.parent != '#'){
							newParentEntry = this.getNode(moveEntry.parent);
							newParentNode = this.getNodeData(moveEntry.parent);
						}

						if(moveEntryContext === 'scopeRole' && newParentEntry.type === 'scope'){
							movementAttributes = {
								scopeID: newParentNode.scopeID
							};
						}

						if(movementAttributes){
							this.performAction(
								this.prepareAction(actionKey, moveNode._primaryKey, undefined, {
									source: {
										submit: {
											data: {
												data: {
													attributes: movementAttributes
												}
											}
										}
									}
								})
							).then(function(){
								// refresh to get the lists up to date after movement
								self.refreshTrees();
							}).fail(function(error){
								// prevent wrong gui state from being displayed
								self.refreshTrees();
							});
						}
						else {
							self.refreshTrees();
							throw new Error('NO MOVEMENT ATTRIBUTES FOUND: ' + actionKey + ', ' + moveEntryContext);
						}
					}
					else {
						self.refreshTrees();
						throw new Error('ACTION NOT FOUND: ' + actionKey);
					}
					break;

				case 'select_node.jstree':
					// TODO: impl. animation and animation-delay
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.scopeTreeActions';
					if(data.onTreeActionOptions.eventData.node.type === 'scopeRole') selector = '.scopeRoleTreeActions';
					this.$.find(selector).show();
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							let modalContentComponent
							if((modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component)){
								if(
									modalContentComponent.hasClass('templates_propertiesForms_scopePropertiesForm')
									||
									modalContentComponent.hasClass('templates_propertiesForms_scopeRolePropertiesForm')
								){
									await modalContentComponent.submit()
                                    await options.decisionComponent.hide()
                                    if(this.hasClass('templates_scopeTrees_selectScopeTrees')){
                                        this.refreshTrees()
                                    }
								}
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break;
					}
					break;

				default:
					// TODO: ERROR;
					break;
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_scopePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_scopePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'scope';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		},
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_scopeRolePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_scopeRolePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'scopeRole';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
